import React, { useState } from 'react';

function WhyUs() {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const features = [
    {
      icon: "🌱",
      title: "Organic Certified",
      desc: "Our products are grown naturally without harmful chemicals, chemical pesticides, or artificial fertilizers, preserving true mineral richness."
    },
    {
      icon: "🚜",
      title: "Direct From Farms",
      desc: "By eliminating intermediate third-party brokers, we ship directly from our local harvest zones straight to your household pipeline."
    },
    {
      icon: "🔒",
      title: "Traceable & Secure Quality",
      desc: "Every package comes with absolute origin transparency, allowing you to trace your food right back to the exact patch of soil it grew in."
    }
  ];

  return (
    <section style={{
      backgroundColor: '#fafaf9',
      padding: '100px 20px',
      fontFamily: 'system-ui, sans-serif',
      overflow: 'hidden'
    }}>
      
      {/* SECTION HEADER BLOCK */}
      <div style={{ textAlign: 'center', marginBottom: '70px' }}>
        <p style={{ color: '#16803d', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '2px', fontSize: '13px', marginBottom: '12px' }}>
          WHY CHOOSE US
        </p>
        <h2 style={{ fontSize: '40px', color: '#1e293b', margin: '0 0 16px 0', fontWeight: '800', letterSpacing: '-1px' }}>
          Pure Quality Food Rooted In Nature
        </h2>
        <p style={{ color: '#64748b', maxWidth: '600px', margin: '0 auto', lineHeight: '1.7', fontSize: '16px' }}>
          Discover how our commitment to traditional eco-friendly agriculture transforms your daily cooking lifestyle.
        </p>
      </div>

      {/* 3D PERSPECTIVE ROW CONTAINER */}
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        gap: '30px',
        flexWrap: 'wrap',
        perspective: '1000px'
      }}>
        {features.map((item, index) => {
          const isHovered = hoveredIndex === index;
          const initialTilt = index === 0 ? -1 : index === 2 ? 1 : 0;

          return (
            <div
              key={index}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              style={{
                width: '350px',
                backgroundColor: '#ffffff',
                borderRadius: '24px',
                padding: '40px 30px',
                textAlign: 'left',
                border: '1px solid #f1f5f9',
                transform: isHovered 
                  ? 'translateZ(40px) rotateX(10deg) rotateY(-5deg) translateY(-10px)' 
                  : `translateZ(0px) rotateX(0deg) rotateY(0deg) rotateZ(${initialTilt}deg)`,
                boxShadow: isHovered
                  ? '0 30px 60px rgba(22,128,61,0.15), 0 12px 25px rgba(0,0,0,0.05)'
                  : '0 10px 25px rgba(0,0,0,0.02)',
                transformStyle: 'preserve-3d',
                transition: 'all 0.5s cubic-bezier(0.25, 1, 0.5, 1)',
                cursor: 'pointer',
                position: 'relative'
              }}
            >
              {/* FLOATING ICON */}
              <div style={{
                fontSize: '48px',
                marginBottom: '28px',
                display: 'inline-block',
                transform: isHovered ? 'translateZ(30px) scale(1.1)' : 'translateZ(0px)',
                transition: 'transform 0.5s ease'
              }}>
                {item.icon}
              </div>

              {/* CARD TITLE TEXT (Fixed Duplicate Key Warning) */}
              <h3 style={{
                fontSize: '22px',
                color: isHovered ? '#16803d' : '#1e293b', // Single dynamic conditional style
                fontWeight: '700',
                margin: '0 0 14px 0',
                transform: isHovered ? 'translateZ(20px)' : 'translateZ(0px)',
                transition: 'all 0.3s ease'
              }}>
                {item.title}
              </h3>

              {/* CARD PARAGRAPH TEXT */}
              <p style={{
                fontSize: '15px',
                color: '#64748b',
                lineHeight: '1.7',
                margin: 0,
                transform: isHovered ? 'translateZ(10px)' : 'translateZ(0px)',
                transition: 'transform 0.5s ease'
              }}>
                {item.desc}
              </p>

              {/* FLOATING DESIGN BACKGROUND ACCENT LINE */}
              <div style={{
                position: 'absolute',
                bottom: '0',
                left: '24px',
                right: '24px',
                height: '4px',
                backgroundColor: '#22c55e',
                borderRadius: '4px 4px 0 0',
                opacity: isHovered ? 1 : 0,
                transform: isHovered ? 'translateZ(15px)' : 'translateZ(0px)',
                transition: 'all 0.4s ease'
              }} />

            </div>
          );
        })}
      </div>

    </section>
  );
}

export default WhyUs;